<template>
  <div class="h-dialogContainer">
    <form id='addDev'>
      <div class="row h-row-inputBox">
        <!-- 设备类型 -->
        <div class="col-sm-6 h-col-inputBox">
          <div>
            <div class="h-inputLit"><span class="h-red-code">* </span>{{this.$t('Topo.devType')}}:</div>
            <ejs-dropdownlist name="devType" :placeholder="devTypePlaceholder" :dataSource="typeData"
              v-model="devinfo.typeCode" :fields="typeFields" :readonly="readDeviceType"
              :change="onDeviceTypeChange" :noRecordsTemplate="noRecordsTemplate" :allowFiltering='true'
              :filtering='onFiltering' :filterBarPlaceholder="filterPlaceholder">
            </ejs-dropdownlist>
          </div>
        </div>
        <!-- 设备名称 -->
        <div class="col-sm-6 h-col-inputBox">
          <div>
            <div class="h-inputLit"><span class="h-red-code">* </span>{{this.$t('Topo.devName')}}:</div>
            <input name="devName" class="e-input" :placeholder="devNamePlaceholder"
              type="text" v-model="devinfo.name"/>
          </div>
        </div>
      </div>
      <div class="row h-row-inputBox">
        <!--neId-->
        <div class="col-sm-6 h-col-inputBox">
          <div>
            <div class="h-inputLit"><span class="h-red-code">* </span>{{this.$t('Observe.neId')}}:</div>
            <input name="id" :placeholder="neIdPlaceholder" v-model="devinfo.id" type="text" class="e-input"/>
          </div>
        </div>
        <!--地区-->
        <div class="col-sm-6 h-col-inputBox">
          <div>
            <div class="h-inputLit"><span class="h-red-code">* </span>{{this.$t('Observe.region')}}:</div>
            <input name="region" :placeholder="regionPlaceholder" v-model="devinfo.region" type="text" class="e-input"/>
          </div>
        </div>
      </div>
      <div class="row h-row-inputBox">
        <div class="col-sm-6 h-col-inputBox">
          <div>
            <div class="h-inputLit"><span class="h-red-code">* </span>{{this.$t('Topo.devSoftVersion')}}:</div>
            <ejs-dropdownlist name="devSoftVersion" :placeholder="devSoftVersionPlaceholder"
              :dataSource="visionData" v-model="devinfo.softwareVersion" :fields="visionFields"
              :readonly="readSoftware" :change="onSoftVersionChange"
              :noRecordsTemplate="noRecordsTemplate">
            </ejs-dropdownlist>
          </div>
        </div>
        <div class="col-sm-6 h-col-inputBox" v-show="isShowPosition">
          <div>
            <div class="h-inputLit">{{this.$t('Topo.altitude')}}:</div>
            <input name="devAltitude" :placeholder="devAltitudePlaceholder" v-model="devinfo.altitude" type="text" class="e-input"/>
          </div>
        </div>
      </div>
      <div class="row h-row-inputBox" v-show="isShowPosition">
        <div class="col-sm-6 h-col-inputBox">
          <div>
            <div class="h-inputLit">{{this.$t('Topo.longitude')}}:</div>
            <input name="devLongitude" :placeholder="devLongitudePlaceholder" v-model="devinfo.longitude" type="text" class="e-input"/>
          </div>
        </div>
        <div class="col-sm-6 h-col-inputBox">
          <div>
            <div class="h-inputLit">{{this.$t('Topo.latitude')}}:</div>
            <input name="devLatitude" :placeholder="devLatitudePlaceholder" v-model="devinfo.latitude" type="text" class="e-input"/>
          </div>
        </div>
      </div>
      <!-- IP和端口 -->
      <!-- <div class="row h-row-inputBox">
        <div class="col-sm-6 h-col-inputBox">
          <div>
            <div class="h-inputLit"><span class="h-red-code">* </span>{{this.$t('Pm.ip')}}:</div>
            <input name="devIP" class="e-input" :placeholder="ipaAddr"
              type="text" v-model="deviceIP"/>
          </div>
        </div>
        <div class="col-sm-6 h-col-inputBox">
          <div>
            <div class="h-inputLit"><span class="h-red-code">* </span>{{this.$t('System.port')}}:</div>
            <input name="devPort" class="e-input" :placeholder="port"
              type="text" v-model="devicePort"/>
          </div>
        </div>
      </div> -->
      <IPAddrList ref='ipAddrList'></IPAddrList>

    </form>
    <div class="h-clear-rowMg"></div>
  </div>
</template>

<script>
  import CustomDialog from '../../../common/CustomDialog';
  import { FormValidator } from '@syncfusion/ej2-vue-inputs';
  import { Query } from '@syncfusion/ej2-data';
  import { EventBus } from '../../../../plugins/eventBus';
  import IPAddrList from '../../../topoconfig/IPAddrList';

  export default {
    name: 'addBSDevice',
    components: {
      CustomDialog,
      IPAddrList
    },
    data() {
      return {
        devTypePlaceholder: this.$t('Topo.devType'), // 设备类型
        readDeviceType: false,
        isShowPosition: true,
        devNamePlaceholder: this.$t('Topo.devName'), // 设备名称
        devSoftVersionPlaceholder: this.$t('Topo.devSelect'), // 版本placeholder
        devLongitudePlaceholder: this.$t('Topo.longitudePlaceholder'), // 经度
        devLatitudePlaceholder: this.$t('Topo.latitudePlaceholder'),  // 纬度
        devAltitudePlaceholder: this.$t('Topo.altitudePlaceholder'),  // 高度
        neIdPlaceholder: this.$t('Observe.neId'), // 网元ID
        regionPlaceholder: this.$t('Observe.region'), // 地区
        noRecordsTemplate: this.$t('Topo.noData'),
        deviceIP: '',
        devicePort: '',
        devinfo: {
          id: '',
          name: '',
          typeCode: 0,
          positionX: 225,
          positionY: 226,
          longitude: '',
          latitude: '',
          altitude: '',
          ipPortData: [],
          softwareVersion: '',
          displaySoftwareVersion:'',
          region:'',
        },
        typeData: [], // 设备码和设备类型数据源
        typeFields: { value: 'typeCode', text: 'nameKey' },
        visionData: [], // 版本和显示版本数据源
        visionFields: { value: 'softwareVersion', text: 'displaySoftwareVersion' },
        type: 0, // 服务器or基站
        readSoftware: false,
        filterPlaceholder: this.$t('Topo.search'),  // ???
        ipaAddr: this.$t('Topo.devIp'),
        port: this.$t('Topo.devPort'),

        validationOption: {
          customPlacement(inputElement, errorElement) {
            errorElement.style.float = 'left';
            inputElement.parentElement.parentElement.appendChild(errorElement);
          },
          rules: {
            devType: {
              required: [true, `${this.$t('Pm.alertRequired')}`],
            },
            devName: {
              required: [true, `${this.$t('Pm.alertRequired')}`],
              regex: [/^(^\S)/, `${this.$t('Topo.noEmptyStart')}`],
              maxLength: [30, `${this.$t('Topo.topoMaxLength')}30`],
            },
            devSoftVersion: {
              required: [true, `${this.$t('Pm.alertRequired')}`],
            },
            id: {
              required: [true, `${this.$t('Pm.alertRequired')}`],
              regex: ['^(\\-|\\+)?\\d+(\\.\\d+)?$', `${this.$t('System.inputNumber')}`],
              maxLength: [5, `${this.$t('Topo.topoMaxLength')}5`],
            },
            // devIP: {
            //   required: [true, `${this.$t('Pm.alertRequired')}`],
            //   regex: ['^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$', `${this.$t('Topo.invalidIPAddress')}`],
            // },
            // devPort: {
            //   required: [true, `${this.$t('Pm.alertRequired')}`],
            //   regex: ['^\\d*$', `${this.$t('Topo.invalidInt')}`],
            //   range: [[1, 65535], `${this.$t('Topo.inputRangeIllegal')}`],
            // },
            devLongitude: {
              regex: ['^(\\-|\\+)?\\d+(\\.\\d+)?$', `${this.$t('System.inputNumber')}`],
              range: [[-180, 180], `${this.$t('Topo.longitudeIllegal')}`],
            },
            devLatitude: {
              regex: ['^(\\-|\\+)?\\d+(\\.\\d+)?$', `${this.$t('System.inputNumber')}`],
              range: [[-90, 90], `${this.$t('Topo.latitudeIllegal')}`],
            },
            devAltitude: {
              regex: ['^(\\-|\\+)?\\d*$', `${this.$t('System.inputInteger')}`],
              range: [[-9999, 9999], `${this.$t('Topo.altitudeIllegal')}`],
            },
          }
        },
      };
    },
    mounted() {
      this.bindValidate();
    },
    methods: {
      bindValidate() {
        this.formObj = new FormValidator('#addDev', this.validationOption);
      },
      validate() {
        const formStatus = this.formObj.validate();
        return formStatus;
      },
      initData(isAddBS, type) {
        if (type != undefined) {
          this.type = type;
        }
        this.queryDevType();
        this.devinfo = {
          id: '',
          name: '',
          typeCode: '',
          equipmentIPList: [],
          softwareVersion: '',
          displaySoftwareVersion:'',
          description: ''
        };
        if (isAddBS !== undefined) {
          this.isShowPosition = isAddBS;
        }
       this.$refs.ipAddrList.addBtnClick();
      },
      outputs(type) {
        if (!this.validate()) return;
        console.log('点击添加操作');
        // this.devinfo.equipmentIPList.push({
        //   id: '',
        //   ip: this.deviceIP,
        //   port: this.devicePort,
        //   service: '',
        //   processCode: '',
        //   equipmentId: '',
        // });

      //校验通信ip和端口
      const IpPortData = this.$refs.ipAddrList.getDatas();
      if(IpPortData === null){
        console.log('IpPortData === null return')
        return;
      }
      for(var k in IpPortData){
        this.devinfo.equipmentIPList.push({
            id: '',
            ip: IpPortData[k].ipaddr,
            port: IpPortData[k].port,
            service:'',
            processCode: '',
            equipmentId: '',
          })
      }
        this.threadIDMatch(this.devinfo.typeCode);
        const devInfo = {
          ...this.devinfo,
          typeCode: this.devinfo.typeCode.toString(),
        };
        //添加设备
        this.axios.post('/lte/ems/topo/device/addDev', devInfo).then(response => {
          if (response && response.status === 200 && response.data && response.data.errorCode === 'SUCCESS') {
            if (type === 'BS') {
              this.$emit('getDeviceListData');
            } else if (type === 'DS') {
              console.log('添加服务器');
              this.$emit('getServiceData');
            }
            EventBus.$emit('toast', {type: 'success', content: this.$t('Track.success')});
            this.closeWindow();
            return;
          } else {
            EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
          }
          this.closeWindow();
        });
      },

      onDeviceTypeChange(e) {
        const devType = parseInt(e.value);
        const This = this;
        const visionDataTemp = [];
        This.devSoftVersionPlaceholder = this.$t('Topo.devSoftVersion');
        This.$axios.get(`/lte/ems/topo/device/devSoftVersion?devType=${devType}&trunkId=${'null'}`).then(response => {
          if (response && response.status === 200 && response.data && response.data.errorCode === 'SUCCESS') {
            for(let k in response.data.resultVal) {
              visionDataTemp.push({
                softwareVersion: k,
                displaySoftwareVersion: response.data.resultVal[k]
              });
            }
          This.visionData = visionDataTemp;
          } else {
            This.visionData = [];
            EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
          }
        });
        // 切换设备类型时调整IP和端口的数量
      const args = {
        typeCode: this.devinfo.typeCode,
      }
       this.$refs.ipAddrList.initArgs(args);
       if( devType !== 10003 ){
         This.devinfo.clusterId = '';
         This.trunkList=[];
       }
      },

      onSoftVersionChange(e){
        if(e.itemData) {
          this.devinfo.displaySoftwareVersion = e.itemData.displaySoftwareVersion;
        }
      },
      closeWindow() {
        this.$emit('close');
      },

      // 新建设备时去后台查设备类型
      queryDevType() {
        const This = this;
        const params={ };
        // This.$axios.get(`/lte/ems/topo/device/devType/${this.type}`,params).then((response) => {
          //只针对ENODEB查询
        This.$axios.get(`/lte/ems/topo/device/devType/2`,params).then((response) => {
          if (response && response.status === 200 && response.data && response.data.errorCode === 'SUCCESS') {
            This.typeData = response.data.resultVal;
            this.devinfo.typeCode=response.data.resultVal[0].typeCode;
          } else {
            This.typeData = [];
            EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
          }
        });
      },
      threadIDMatch(value) {
        if(2==this.devinfo.equipmentIPList.length){
        if (value === 10001 ) {
          this.devinfo.equipmentIPList[0].service = 'epc';
          this.devinfo.equipmentIPList[1].service = 'epc';
        } else if (value === 10004 || value === 10005 || value === 10006 || value === 10008) {
          this.devinfo.equipmentIPList[0].service = 'enodeb';
          this.devinfo.equipmentIPList[1].service = 'enodeb';
        } else if (value === 10009) {
          this.devinfo.equipmentIPList[0].service = 'gnb';
          this.devinfo.equipmentIPList[1].service = 'gnb';
        }}
        else if(1==this.devinfo.equipmentIPList.length){
          if (value === 10001 ) {
          this.devinfo.equipmentIPList[0].service = 'epc';
        } else if (value === 10004 || value === 10005 || value === 10006 || value === 10008) {
          this.devinfo.equipmentIPList[0].service = 'enodeb';
        } else if (value === 10009) {
          this.devinfo.equipmentIPList[0].service = 'gnb';
        }
        }
      },

      onFiltering(e){
        let query = new Query();
        query = (e.text !== '') ? query.where('nameKey', 'startswith', e.text, true) : query;
        e.updateData(this.typeData, query);
      },
    }
  };
</script>

